App.Events = {
    onAjaxUpdate: function(){

        App.Video.init();
        App.Gallery.init();
        App.Slider2.init();

        setTimeout(function(){
            $('[data-popup-simplebar]').each(function(){
                new SimpleBar($(this)[0]);
            });
        }, 100);

    }
};

App.isMobile = function(){
    return $(window).width() <= 1024;
};
App.isPhone = function(){
    return $(window).width() < 768;
};

App.userAgent = detect.parse(navigator.userAgent);
App.isBrowser = function(name){
    return name == App.userAgent.browser.family;
}
$('html').addClass('browser-'+App.userAgent.browser.family);
$('html').addClass('os-'+App.userAgent.os.family.split(' ')[0]);

// отучаю визуальный редактор резать тэги
try {
    BX.addCustomEvent('OnEditorInitedBefore', function(toolbar) {
        var _this = this;

        BX.addCustomEvent(this, 'OnGetParseRules', BX.proxy(function() {
            _this.rules.tags.span   = {};
            _this.rules.tags.svg    = {};
            _this.rules.tags.use    = {};
        }, this));
    });
} catch (e){
    console.log(e);
}